module.exports = __webpack_public_path__ + "img/road-vehicle.fd532a8e.png";